import { TFunction } from 'i18next'
import { IdentificationType } from 'constants/enums/identificationType'
import { AllCountries, euCountries } from 'constants/enums/countryTypes'
import { IOption } from 'formBuilder/src'

const euIdentificationTypes: IdentificationType[] = [
	IdentificationType.IdCard,
	IdentificationType.Passport,
]

const nonEuIdentificationTypes: IdentificationType[] = [
	IdentificationType.ResidenceTitle,
]

export function getIdentificationTypeOptions(
	nationality: AllCountries | string | undefined | null,
	t: TFunction,
): IOption[] {
	if (!nationality) return []

	// nationality is stored as the AllCountries enum KEY (e.g. 'IT'), see GetAllCitizenshipsWithTranslation, whereas euCountries holds the enum VALUES (e.g. 'Italy') - so it has to be resolved to its value before the euCountries check.
	const nationalityValue =
		AllCountries[nationality as keyof typeof AllCountries]
	const types = euCountries.includes(nationalityValue)
		? euIdentificationTypes
		: nonEuIdentificationTypes

	return types.map((identificationType) => ({
		value: identificationType,
		label: t(identificationType),
	}))
}
